<template>
  <span> {{ $setInfoDecimal(Surplus) }}</span>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('user',['userSurplus']),
    Surplus () {
      return this.userSurplus
    }
  },
  methods: {
  ...mapActions('user',['getSurplus']),
  },
  created() {
    this.getSurplus()
  },
}
</script>